import { Column } from "@ant-design/plots";
import chartData from "../../Components/chart-data.json";

export default function Chart() {
  const config = {
    data: chartData,
    xField: "year",
    yField: "value",
    colorField: "type",
    isStack: true,
    stack: true,
    color: ({ type }: { type: string }) => {
      return type === "Direct costs" ? "#000000" : "#3c3c3c";
    },
    columnStyle: {
      radius: [16, 16, 0, 0],
    },

    tooltip: {
      customContent: (
        title: string,
        items: {
          name: string;
          value: string | number;
          color: string;
        }[] = []
      ) => {
        return (
          <div key={title}>
            <h4>{title}</h4>
            {items.map((item, idx) => {
              const { name, value, color } = item;
              return (
                <div key={idx}>
                  <div
                    style={{
                      margin: 0,
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <span
                        style={{
                          display: "inline-block",
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          backgroundColor: color,
                          marginRight: 6,
                        }}
                      ></span>
                      <span>{name}</span>
                    </div>
                    <b>{value}</b>
                  </div>
                </div>
              );
            })}
          </div>
        );
      },
    },
  };

  return <Column {...config} />;
}
